module.exports = __webpack_public_path__ + "img/map__currentlocation__icon.f7edee2f.svg";